export default __webpack_public_path__ + "static/media/ui_banner_footer_01.2372cf9a.png";